var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RequestUpdated',{attrs:{"request-type":"leave","notification":_vm.notification,"active-notification":_vm.activeNotification},on:{"show-more-details":function($event){return _vm.$emit('click', _vm.notification)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }